import axiosInstance from "../../axiosInstance";

// دالة لإنشاء فيديو
export const createVideo = async (videoData) => {
  try {
    const response = await axiosInstance.post('/api/v1/speakers/videos', videoData);
    return response.data;
  } catch (error) {
    console.error('Error creating video:', error);
    throw error;
  }
};

// دالة لجلب قائمة الفيديوهات
export const getVideos = async (params) => {
  try {
    const response = await axiosInstance.get('/api/v1/speakers/videos', {
      params: {
        Page: params.page,
        PageCount: params.pageCount
      }
    });
    return response;
  } catch (error) {
    console.error('Error retrieving videos:', error);
    throw error;
  }
};

// دالة لقراءة فيديو محدد
export const getVideoById = async (videoId, userId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/speakers/videos/${videoId}`, {
      params: {
        userId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error retrieving video:', error);
    throw error;
  }
};

// دالة لتحديث فيديو
export const updateVideo = async (videoId, updatedData) => {
  try {
    const response = await axiosInstance.put(`/api/v1/speakers/videos/${videoId}`, updatedData);
    return response.data;
  } catch (error) {
    console.error('Error updating video:', error);
    throw error;
  }
};

// دالة لحذف فيديو
export const deleteVideo = async (videoId) => {
  try {
    const response = await axiosInstance.delete(`/api/v1/speakers/videos/${videoId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting video:', error);
    throw error;
  }
};